import { useState } from 'react';
import { Button, Card, CardBody, CardHeader, Input } from '@nextui-org/react';
import {
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup
} from 'firebase/auth';
import { Navigate, useLocation } from 'react-router-dom';
import { auth } from '../lib/firebase';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/users';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (!loading && user) {
    return <Navigate to={from} replace />;
  }

  async function doEmail(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      // onAuthStateChanged fires → useAuth updates → <Navigate> above redirects.
    } catch (err) {
      setError(err.message || 'Login failed');
      setBusy(false);
    }
  }

  async function doGoogle() {
    setBusy(true);
    setError(null);
    try {
      await signInWithPopup(auth, new GoogleAuthProvider());
    } catch (err) {
      setError(err.message || 'Login failed');
      setBusy(false);
    }
  }

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="flex-col items-start gap-1">
          <div className="text-xs uppercase tracking-wider text-default-500">
            TikControl
          </div>
          <div className="text-xl font-semibold">Backoffice</div>
        </CardHeader>
        <CardBody className="gap-3">
          <form onSubmit={doEmail} className="flex flex-col gap-3">
            <Input
              type="email"
              label="Email"
              value={email}
              onValueChange={setEmail}
              autoComplete="email"
              isRequired
            />
            <Input
              type="password"
              label="Contraseña"
              value={password}
              onValueChange={setPassword}
              autoComplete="current-password"
              isRequired
            />
            <Button type="submit" color="primary" isLoading={busy}>
              Entrar
            </Button>
          </form>
          <div className="text-center text-xs text-default-500">o</div>
          <Button variant="flat" onPress={doGoogle} isDisabled={busy}>
            Continuar con Google
          </Button>
          {error && <p className="text-sm text-danger">{error}</p>}
        </CardBody>
      </Card>
    </div>
  );
}
